export enum WebsiteAnalyticCredentialType {
  META_PIXEL = 'META_PIXEL',
  GOOGLE_ANALYTICS = 'GOOGLE_ANALYTICS',
  GOOGLE_TAG_MANAGER = 'GOOGLE_TAG_MANAGER',
  TIKTOK_PIXEL = 'TIKTOK_PIXEL',
}

export enum Social {
  linkedIn = 'linkedIn',
  youTube = 'youTube',
  facebook = 'facebook',
  twitter = 'twitter',
  instagram = 'instagram',
  tikTok = 'tikTok',
  telegram = 'telegram',
}

export enum Action {
  BOOK_ME = 'BOOK_ME',
  ASK_ME = 'ASK_ME',
}
